import React from "react";
import {Head, useForm} from "@inertiajs/react";
import {Button} from "primereact/button";
import {Checkbox} from "primereact/checkbox";
import {InputText} from "primereact/inputtext";
import "primereact/resources/primereact.css";
import AuthLayout from "@/Layouts/Auth/AuthLayout";
import {route} from 'ziggy-js';
import { Link } from '@inertiajs/react';

export default function Login() {
    const pageTitle = 'Log in';

    const {data, setData, post, processing, errors, reset} = useForm({
        email: '',
        password: '',
        remember: false,
    });

    const submit = (e) => {
        e.preventDefault();

        post(route('admin.auth.authenticate'), {
            onFinish: () => reset('password'),
        });
    };

    return (
        <>
            {/*Page meta title*/}
            <Head title={pageTitle}/>

            <AuthLayout title={pageTitle} subtitle={'Please enter your details subtitle'}>
                <div className="flex flex-column">
                    <div className="p-input-icon-left w-full mb-4">
                        <i className="pi pi-envelope"></i>
                        <InputText
                            id="email"
                            type="text"
                            onChange={(event) =>
                                setData("email", event.currentTarget.value)
                            }
                            value={data.email}
                            className="w-full md:w-25rem"
                            placeholder="Email"
                            invalid={!!errors.email}
                        />
                    </div>
                    {errors.email && (
                        <small className="p-error"
                               style={{marginTop: '-15px', marginBottom: '15px'}}>{errors.email}</small>
                    )}
                    <div className="p-input-icon-left w-full mb-4">
                        <i className="pi pi-lock"></i>
                        <InputText
                            id="password"
                            type="password"
                            onChange={(event) =>
                                setData(
                                    "password",
                                    event.currentTarget.value,
                                )
                            }
                            value={data.password}
                            className="w-full md:w-25rem"
                            placeholder="Password"
                            invalid={!!errors.password}
                        />
                    </div>
                    {errors.password && (
                        <small className="p-error"
                               style={{marginTop: '-15px', marginBottom: '15px'}}>{errors.password}</small>
                    )}
                    <div className="mb-4 flex flex-wrap gap-3">
                        <div>
                            <Checkbox
                                name="checkbox"
                                value={data.remember}
                                checked={data.remember}
                                onChange={() =>
                                    setData("remember", !data.remember)
                                }
                                className="mr-2"
                            ></Checkbox>
                            <label
                                htmlFor="checkbox"
                                className="text-900 font-medium mr-8"
                            >
                                Remember Me
                            </label>
                        </div>
                        <Link className="text-600 hover:text-primary  ml-auto transition-colors transition-duration-300"
                              href={route('admin.auth.password.request')}>Forgot Password</Link>
                    </div>
                        <Button
                            label="Log In"
                            className="w-full"
                            onClick={submit}
                        />
                    </div>
            </AuthLayout>
        </>
);
}
